(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["AT-collection-list"] && !Shopify.designMode) return;
  try {
    
(function () {
  var MEDIA_QUERY = '(max-width: 768px)';
  var SWIPER_CSS = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
  var SWIPER_JS = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
  var registry = {};
  var videoObserver = null;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function getVideoObserver() {
    if (videoObserver) return videoObserver;
    if (!('IntersectionObserver' in window)) return null;

    videoObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var media = entry.target;
        videoObserver.unobserve(media);

        var video = media.querySelector('video');
        var iframe = media.querySelector('iframe[data-src]');
        var source = media.querySelector('source[data-src]');

        function hidePoster() {
          media.classList.add('is-playing');
        }

        if (video) {
          if (source && source.dataset.src) {
            source.src = source.dataset.src;
            video.load();
          }
          video.muted = true;
          video.defaultMuted = true;
          video.playsInline = true;
          video.setAttribute('muted', '');
          video.setAttribute('playsinline', '');
          video.controls = false;
          video.addEventListener('playing', hidePoster);
          if (!prefersReducedMotion()) {
            var playPromise = video.play();
            if (playPromise && playPromise.catch) playPromise.catch(function () {});
          }
        }

        if (iframe && iframe.dataset.src) {
          iframe.src = iframe.dataset.src;
          iframe.addEventListener('load', function () {
            window.setTimeout(hidePoster, 500);
          });
        }
      });
    }, { rootMargin: '100px', threshold: 0.25 });

    return videoObserver;
  }

  function loadSwiper() {
    if (window.Swiper) return Promise.resolve(window.Swiper);
    if (window.atClSwiperLoader) return window.atClSwiperLoader;

    window.atClSwiperLoader = new Promise(function (resolve, reject) {
      if (!document.querySelector('link[data-at-cl-swiper]')) {
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = SWIPER_CSS;
        link.setAttribute('data-at-cl-swiper', '');
        document.head.appendChild(link);
      }

      var existingScript = document.querySelector('script[data-at-cl-swiper]');
      if (existingScript) {
        existingScript.addEventListener('load', function () { resolve(window.Swiper); });
        existingScript.addEventListener('error', reject);
        return;
      }

      var script = document.createElement('script');
      script.src = SWIPER_JS;
      script.async = true;
      script.setAttribute('data-at-cl-swiper', '');
      script.onload = function () { resolve(window.Swiper); };
      script.onerror = reject;
      document.head.appendChild(script);
    });

    return window.atClSwiperLoader;
  }

  function AtCollectionList(root) {
    this.root = root;
    this.wrap = root.querySelector('[data-at-cl-wrap]');
    this.el = root.querySelector('[data-at-cl-slider]');
    this.needsSwiper = root.getAttribute('data-needs-swiper') === 'true';
    this.destroyed = false;
    this.swiper = null;
    this.initToken = 0;
    this.mq = window.matchMedia(MEDIA_QUERY);
    this.onChange = this.sync.bind(this);

    if (!this.wrap || !this.el) return;

    this.desktopLayout = this.wrap.getAttribute('data-desktop-layout') || 'grid';
    this.mobileLayout = this.wrap.getAttribute('data-mobile-layout') || 'grid';
    this.desktopPerView = Number(this.wrap.getAttribute('data-slider-per-row-desktop')) || 4;
    this.mobilePerView = Number(this.wrap.getAttribute('data-slider-per-row-mobile')) || 2;

    if (this.mq.addEventListener) {
      this.mq.addEventListener('change', this.onChange);
    } else if (this.mq.addListener) {
      this.mq.addListener(this.onChange);
    }

    this.bindMedia();
    if (this.needsSwiper) {
      this.sync();
    }
  }

  AtCollectionList.prototype.bindMedia = function () {
    if (!this.root) return;
    var observer = getVideoObserver();

    this.root.querySelectorAll('[data-at-cl-video]').forEach(function (media) {
      if (media.getAttribute('data-at-cl-bound') === 'true') return;
      media.setAttribute('data-at-cl-bound', 'true');
      if (observer) {
        observer.observe(media);
      }
    });
  };

  AtCollectionList.prototype.isMobile = function () {
    return this.mq.matches;
  };

  AtCollectionList.prototype.currentLayout = function () {
    return this.isMobile() ? this.mobileLayout : this.desktopLayout;
  };

  AtCollectionList.prototype.currentPerView = function () {
    return this.isMobile() ? this.mobilePerView : this.desktopPerView;
  };

  AtCollectionList.prototype.currentGap = function () {
    return this.isMobile()
      ? Number(getComputedStyle(this.root).getPropertyValue('--at-cl-gap-m').replace('px', '')) || 16
      : Number(getComputedStyle(this.root).getPropertyValue('--at-cl-gap').replace('px', '')) || 20;
  };

  AtCollectionList.prototype.sync = function () {
    if (this.destroyed || !this.needsSwiper) return;
    if (this.currentLayout() === 'slider') {
      this.initSwiper();
    } else {
      this.setStatic(false);
      this.destroySwiper();
    }
  };

  AtCollectionList.prototype.setStatic = function (isStatic, count) {
    if (!this.wrap || !this.el) return;
    this.wrap.classList.toggle('at-cl--static', Boolean(isStatic));
    this.el.classList.toggle('at-cl--static', Boolean(isStatic));
    if (isStatic && count) {
      this.wrap.style.setProperty('--at-cl-static-cols', String(count));
    } else {
      this.wrap.style.removeProperty('--at-cl-static-cols');
    }
  };

  AtCollectionList.prototype.initSwiper = async function () {
    if (this.destroyed || !this.el) return;

    var token = ++this.initToken;
    var slides = this.el.querySelectorAll('.swiper-slide');
    var perView = this.currentPerView();
    var spaceBetween = this.currentGap();
    var reduceMotion = prefersReducedMotion();

    if (slides.length <= perView) {
      this.destroySwiper();
      this.setStatic(true, slides.length || perView);
      return;
    }

    this.setStatic(false);

    if (this.swiper) {
      this.swiper.params.slidesPerView = perView;
      this.swiper.params.spaceBetween = spaceBetween;
      this.swiper.update();
      return;
    }

    try {
      await loadSwiper();
    } catch (error) {
      return;
    }

    if (this.destroyed || token !== this.initToken || !this.el || !this.el.isConnected || this.currentLayout() !== 'slider') return;
    if (this.swiper) return;

    slides = this.el.querySelectorAll('.swiper-slide');
    if (slides.length <= perView) {
      this.setStatic(true, slides.length || perView);
      return;
    }

    this.swiper = new window.Swiper(this.el, {
      slidesPerView: perView,
      spaceBetween: spaceBetween,
      loop: false,
      watchOverflow: true,
      grabCursor: !reduceMotion,
      simulateTouch: true,
      allowTouchMove: true,
      followFinger: true,
      threshold: 8,
      speed: reduceMotion ? 0 : 450,
      watchSlidesProgress: true,
      observer: true,
      observeParents: true,
      resizeObserver: true,
      preventClicks: true,
      preventClicksPropagation: false,
      slideToClickedSlide: false,
      keyboard: {
        enabled: true,
        onlyInViewport: true
      },
      a11y: {
        enabled: true,
        prevSlideMessage: 'Previous collections',
        nextSlideMessage: 'Next collections'
      },
      navigation: {
        nextEl: this.wrap.querySelector('[data-at-cl-next]'),
        prevEl: this.wrap.querySelector('[data-at-cl-prev]')
      },
      pagination: {
        el: this.wrap.querySelector('[data-at-cl-pagination]'),
        type: 'progressbar'
      }
    });
    this.bindMedia();
  };

  AtCollectionList.prototype.destroySwiper = function () {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  };

  AtCollectionList.prototype.destroy = function () {
    this.destroyed = true;
    this.initToken += 1;
    if (this.mq) {
      if (this.mq.removeEventListener) {
        this.mq.removeEventListener('change', this.onChange);
      } else if (this.mq.removeListener) {
        this.mq.removeListener(this.onChange);
      }
    }
    this.destroySwiper();
    this.root = null;
    this.wrap = null;
    this.el = null;
  };

  function mount(root) {
    if (!root || !root.id) return;
    unmount(root);
    registry[root.id] = new AtCollectionList(root);
  }

  function unmount(root) {
    if (!root || !root.id || !registry[root.id]) return;
    registry[root.id].destroy();
    delete registry[root.id];
  }

  function initAll() {
    document.querySelectorAll('[data-at-collection-list]').forEach(mount);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-at-collection-list]');
    if (root) mount(root);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('[data-at-collection-list]');
    if (root) {
      unmount(root);
      return;
    }
    if (event.detail && event.detail.sectionId) {
      var fallbackId = 'at-collection-list__section-' + event.detail.sectionId;
      if (registry[fallbackId]) {
        registry[fallbackId].destroy();
        delete registry[fallbackId];
      }
    }
  });

  document.addEventListener('shopify:section:reorder', function (event) {
    var root = event.target.closest('[data-at-collection-list]') || event.target.querySelector('[data-at-collection-list]');
    if (root && registry[root.id] && registry[root.id].swiper) {
      registry[root.id].swiper.update();
    }
  });

  document.addEventListener('shopify:block:select', function (event) {
    var root = event.target.closest('[data-at-collection-list]');
    var slide = event.target.closest('.swiper-slide');
    if (!root || !slide || !registry[root.id] || !registry[root.id].swiper) return;
    var index = Array.prototype.indexOf.call(slide.parentNode.children, slide);
    registry[root.id].swiper.slideTo(index);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-lead-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('custom-lead-form')) return;

    var EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    var PHONE_PATTERN = /^\+?[0-9\s().\-]{7,20}$/;

    function digitCount(value) {
      return (value.match(/\d/g) || []).length;
    }

    class CustomLeadForm extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.form = this.querySelector('form');
        this.submitButton = this.querySelector('[data-clf-submit]');
        this.buttonLabel = this.querySelector('[data-clf-button-label]');
        this.buttonLoading = this.querySelector('[data-clf-button-loading]');
        this.summary = this.querySelector('[data-clf-summary]');
        this.summaryTitle = this.querySelector('[data-clf-summary-title]');
        this.status = this.querySelector('[data-clf-status]');
        this.submitting = false;

        if (this.status) {
          this.status.focus();
          return;
        }

        if (!this.form || !this.submitButton) return;

        this.form.setAttribute('novalidate', 'novalidate');
        this.form.addEventListener('submit', this.onSubmit.bind(this));
        this.form.addEventListener('input', this.onInput.bind(this), true);
      }

      onInput(event) {
        var field = event.target.closest('[data-clf-field]');
        if (!field || !event.target.matches('input')) return;
        if (event.target.getAttribute('aria-invalid') === 'true') {
          this.clearFieldError(event.target);
          this.maybeHideSummary();
        }
      }

      onSubmit(event) {
        if (this.submitting) {
          event.preventDefault();
          return;
        }

        if (!this.validate()) {
          event.preventDefault();
          return;
        }

        this.setSubmitting(true);
      }

      validate() {
        var fields = this.querySelectorAll('[data-clf-field] input');
        var firstInvalid = null;
        var filledCount = 0;

        fields.forEach(function (input) {
          if ((input.value || '').trim()) filledCount += 1;
        });

        if (filledCount === 0) {
          this.showSummary(this.dataset.errorEmpty || '');
          if (fields[0]) fields[0].focus();
          return false;
        }

        fields.forEach((input) => {
          var message = this.getErrorMessage(input);
          if (message) {
            this.showFieldError(input, message);
            if (!firstInvalid) firstInvalid = input;
          } else {
            this.clearFieldError(input);
          }
        });

        if (firstInvalid) {
          this.showSummary(this.dataset.errorHeading || '');
          firstInvalid.focus();
          return false;
        }

        this.hideSummary();
        return true;
      }

      getErrorMessage(input) {
        var value = (input.value || '').trim();
        var required = input.hasAttribute('required');
        var type = input.getAttribute('data-clf-type');

        if (!value) {
          return required ? input.getAttribute('data-error-required') || '' : '';
        }

        if (type === 'email' && !EMAIL_PATTERN.test(value)) {
          return input.getAttribute('data-error-invalid') || '';
        }

        if (type === 'phone') {
          var digits = digitCount(value);
          if (!PHONE_PATTERN.test(value) || digits < 7 || digits > 15) {
            return input.getAttribute('data-error-invalid') || '';
          }
        }

        if (type === 'age') {
          var age = Number(value);
          if (!/^\d+$/.test(value) || age < 1 || age > 120) {
            return input.getAttribute('data-error-invalid') || '';
          }
        }

        return '';
      }

      showFieldError(input, message) {
        var error = input.parentElement.querySelector('[data-clf-field-error]');
        input.classList.add('is-invalid');
        input.setAttribute('aria-invalid', 'true');
        if (error) {
          error.hidden = false;
          error.textContent = message;
        }
      }

      clearFieldError(input) {
        var error = input.parentElement.querySelector('[data-clf-field-error]');
        input.classList.remove('is-invalid');
        input.setAttribute('aria-invalid', 'false');
        if (error) {
          error.hidden = true;
          error.textContent = '';
        }
      }

      showSummary(message) {
        if (!this.summary) return;
        if (this.summaryTitle) this.summaryTitle.textContent = message;
        this.summary.hidden = false;
      }

      hideSummary() {
        if (!this.summary) return;
        this.summary.hidden = true;
      }

      maybeHideSummary() {
        var invalid = this.querySelectorAll('input[aria-invalid="true"]');
        if (!invalid.length) this.hideSummary();
      }

      setSubmitting(isSubmitting) {
        this.submitting = isSubmitting;
        this.form.setAttribute('aria-busy', isSubmitting ? 'true' : 'false');
        this.submitButton.setAttribute('aria-disabled', isSubmitting ? 'true' : 'false');
        this.submitButton.classList.toggle('is-loading', isSubmitting);
        if (this.buttonLabel) this.buttonLabel.hidden = isSubmitting;
        if (this.buttonLoading) this.buttonLoading.hidden = !isSubmitting;
      }
    }

    customElements.define('custom-lead-form', CustomLeadForm);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-gallery-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var MEDIA_QUERY = '(max-width: 768px)';
    var SWIPER_CSS = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
    var SWIPER_JS = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';

    function prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function loadSwiper() {
      if (window.Swiper) return Promise.resolve(window.Swiper);
      if (window.atClSwiperLoader) return window.atClSwiperLoader;
      if (window.iggSwiperLoader) return window.iggSwiperLoader;

      window.iggSwiperLoader = new Promise(function (resolve, reject) {
        if (!document.querySelector('link[data-at-cl-swiper], link[data-igg-swiper]')) {
          var link = document.createElement('link');
          link.rel = 'stylesheet';
          link.href = SWIPER_CSS;
          link.setAttribute('data-igg-swiper', '');
          document.head.appendChild(link);
        }

        var existingScript = document.querySelector('script[data-at-cl-swiper], script[data-igg-swiper]');
        if (existingScript) {
          existingScript.addEventListener('load', function () { resolve(window.Swiper); });
          existingScript.addEventListener('error', reject);
          return;
        }

        var script = document.createElement('script');
        script.src = SWIPER_JS;
        script.async = true;
        script.setAttribute('data-igg-swiper', '');
        script.onload = function () { resolve(window.Swiper); };
        script.onerror = reject;
        document.head.appendChild(script);
      });

      return window.iggSwiperLoader;
    }

    if (!customElements.get('image-gallery-grid')) {
      class ImageGalleryGrid extends HTMLElement {
        connectedCallback() {
          this.mq = window.matchMedia(MEDIA_QUERY);
          this.mobileCols = Number(this.dataset.colsMobile) || 1;
          this.swipers = {};
          this.initToken = 0;
          this.onResize = this.syncSwipers.bind(this);

          if (this.mq.addEventListener) {
            this.mq.addEventListener('change', this.onResize);
          } else if (this.mq.addListener) {
            this.mq.addListener(this.onResize);
          }

          this.initLightbox();
          if (this.dataset.layout === 'mosaic') {
            this.syncSwipers();
          }
        }

        disconnectedCallback() {
          document.removeEventListener('keydown', this.onKeydown);
          if (this.mq) {
            if (this.mq.removeEventListener) {
              this.mq.removeEventListener('change', this.onResize);
            } else if (this.mq.removeListener) {
              this.mq.removeListener(this.onResize);
            }
          }
          this.destroyAllSwipers();
        }

        isMobile() {
          return this.mq.matches;
        }

        getGap() {
          var styles = getComputedStyle(this);
          return this.isMobile()
            ? Number(styles.getPropertyValue('--igg-gap-mobile').replace('px', '')) || 8
            : Number(styles.getPropertyValue('--igg-gap').replace('px', '')) || 12;
        }

        getActiveGalleryRoot() {
          if (this.dataset.layout !== 'mosaic') {
            return this;
          }
          return this.isMobile()
            ? this.querySelector('[data-igg-mobile]')
            : this.querySelector('[data-igg-desktop]');
        }

        refreshTriggers() {
          var root = this.getActiveGalleryRoot() || this;
          this.triggerCount = root.querySelectorAll('[data-igg-trigger]').length;
        }

        getTriggerByIndex(index) {
          var root = this.getActiveGalleryRoot() || this;
          return root.querySelector('[data-igg-trigger][data-igg-index="' + index + '"]');
        }

        initLightbox() {
          if (this.dataset.lightbox !== 'true') return;

          this.lightbox = this.querySelector('[data-igg-lightbox]');
          this.imageEl = this.querySelector('[data-igg-image]');
          this.counterEl = this.querySelector('[data-igg-counter]');
          this.index = 0;

          this.onTriggerClick = this.onTriggerClick.bind(this);
          this.onKeydown = this.onKeydown.bind(this);
          this.close = this.close.bind(this);
          this.prev = this.prev.bind(this);
          this.next = this.next.bind(this);

          this.refreshTriggers();
          this.addEventListener('click', function (event) {
            var trigger = event.target.closest('[data-igg-trigger]');
            if (!trigger || !this.contains(trigger)) return;
            var galleryRoot = this.getActiveGalleryRoot() || this;
            if (!galleryRoot.contains(trigger)) return;
            event.preventDefault();
            this.index = Number(trigger.dataset.iggIndex || 0);
            this.open();
          }.bind(this));

          this.querySelector('[data-igg-close]')?.addEventListener('click', this.close);
          this.lightbox?.querySelector('[data-igg-prev]')?.addEventListener('click', this.prev);
          this.lightbox?.querySelector('[data-igg-next]')?.addEventListener('click', this.next);
          this.lightbox?.addEventListener('click', function (event) {
            if (event.target === this.lightbox) this.close();
          }.bind(this));
        }

        syncSwipers() {
          if (this.dataset.layout !== 'mosaic') return;

          if (this.isMobile()) {
            this.destroySwiper('desktop');
            this.initMobileSwiper();
          } else {
            this.destroySwiper('mobile');
            if (this.dataset.needsDesktopMosaicSwiper === 'true') {
              this.initDesktopSwiper();
            } else {
              this.destroySwiper('desktop');
            }
          }

          this.refreshTriggers();
        }

        async initMobileSwiper() {
          var token = ++this.initToken;
          var wrap = this.querySelector('[data-igg-slider-wrap="mobile"]');
          var sliderEl = this.querySelector('[data-igg-swiper="mobile"]');
          if (!wrap || !sliderEl) return;

          var slides = sliderEl.querySelectorAll('.swiper-slide');
          var perView = this.mobileCols;
          var spaceBetween = this.getGap();
          var reduceMotion = prefersReducedMotion();

          if (slides.length <= perView) {
            this.destroySwiper('mobile');
            wrap.classList.add('igg__slider-wrap--static');
            return;
          }

          wrap.classList.remove('igg__slider-wrap--static');

          if (this.swipers.mobile) {
            this.swipers.mobile.params.slidesPerView = perView;
            this.swipers.mobile.params.spaceBetween = spaceBetween;
            this.swipers.mobile.update();
            return;
          }

          try {
            await loadSwiper();
          } catch (error) {
            return;
          }

          if (token !== this.initToken || !sliderEl.isConnected || !this.isMobile()) return;

          this.swipers.mobile = new window.Swiper(sliderEl, {
            slidesPerView: perView,
            spaceBetween: spaceBetween,
            loop: false,
            watchOverflow: true,
            grabCursor: !reduceMotion,
            speed: reduceMotion ? 0 : 450,
            observer: true,
            observeParents: true,
            resizeObserver: true,
            keyboard: {
              enabled: true,
              onlyInViewport: true
            },
            navigation: {
              nextEl: wrap.querySelector('[data-igg-slider-next]'),
              prevEl: wrap.querySelector('[data-igg-slider-prev]')
            },
            pagination: {
              el: wrap.querySelector('[data-igg-pagination]'),
              type: 'progressbar'
            }
          });
        }

        async initDesktopSwiper() {
          var token = ++this.initToken;
          var wrap = this.querySelector('[data-igg-slider-wrap="desktop"]');
          var sliderEl = this.querySelector('[data-igg-swiper="desktop"]');
          if (!wrap || !sliderEl) return;

          var slides = sliderEl.querySelectorAll('.swiper-slide');
          var spaceBetween = this.getGap();
          var reduceMotion = prefersReducedMotion();

          if (slides.length <= 1) {
            this.destroySwiper('desktop');
            wrap.classList.add('igg__slider-wrap--static');
            return;
          }

          wrap.classList.remove('igg__slider-wrap--static');

          if (this.swipers.desktop) {
            this.swipers.desktop.params.spaceBetween = spaceBetween;
            this.swipers.desktop.update();
            return;
          }

          try {
            await loadSwiper();
          } catch (error) {
            return;
          }

          if (token !== this.initToken || !sliderEl.isConnected || this.isMobile()) return;

          this.swipers.desktop = new window.Swiper(sliderEl, {
            slidesPerView: 1,
            spaceBetween: spaceBetween,
            loop: false,
            watchOverflow: true,
            grabCursor: !reduceMotion,
            speed: reduceMotion ? 0 : 450,
            observer: true,
            observeParents: true,
            resizeObserver: true,
            keyboard: {
              enabled: true,
              onlyInViewport: true
            },
            navigation: {
              nextEl: wrap.querySelector('[data-igg-slider-next]'),
              prevEl: wrap.querySelector('[data-igg-slider-prev]')
            },
            pagination: {
              el: wrap.querySelector('[data-igg-pagination]'),
              type: 'progressbar'
            }
          });
        }

        destroySwiper(name) {
          if (this.swipers[name]) {
            this.swipers[name].destroy(true, true);
            this.swipers[name] = null;
          }
        }

        destroyAllSwipers() {
          this.destroySwiper('mobile');
          this.destroySwiper('desktop');
        }

        onTriggerClick(event) {
          event.preventDefault();
          this.index = Number(event.currentTarget.dataset.iggIndex || 0);
          this.open();
        }

        open() {
          if (!this.lightbox) return;
          this.renderSlide();
          this.lightbox.hidden = false;
          this.lightbox.classList.add('is-open');
          document.documentElement.style.overflow = 'hidden';
          document.addEventListener('keydown', this.onKeydown);
        }

        close() {
          if (!this.lightbox) return;
          this.lightbox.classList.remove('is-open');
          this.lightbox.hidden = true;
          document.documentElement.style.overflow = '';
          document.removeEventListener('keydown', this.onKeydown);
        }

        prev() {
          if (!this.lightbox?.classList.contains('is-open')) return;
          var count = this.triggerCount || 1;
          this.index = (this.index - 1 + count) % count;
          this.renderSlide();
        }

        next() {
          if (!this.lightbox?.classList.contains('is-open')) return;
          var count = this.triggerCount || 1;
          this.index = (this.index + 1) % count;
          this.renderSlide();
        }

        renderSlide() {
          var trigger = this.getTriggerByIndex(this.index);
          if (!trigger || !this.imageEl) return;
          this.imageEl.src = trigger.dataset.iggFull || '';
          this.imageEl.alt = trigger.dataset.iggAlt || '';
          if (this.counterEl) {
            this.counterEl.textContent = `${this.index + 1} / ${this.triggerCount}`;
          }
        }

        onKeydown(event) {
          if (event.key === 'Escape') this.close();
          if (event.key === 'ArrowLeft') this.prev();
          if (event.key === 'ArrowRight') this.next();
        }
      }

      customElements.define('image-gallery-grid', ImageGalleryGrid);
    }

    document.addEventListener('shopify:block:select', function (event) {
      var root = event.target.closest('image-gallery-grid');
      if (!root || root.dataset.layout !== 'mosaic') return;

      var slide = event.target.closest('.swiper-slide');
      if (!slide) return;

      var sliderEl = slide.closest('[data-igg-swiper]');
      if (!sliderEl || !sliderEl.swiper) return;

      var index = Array.prototype.indexOf.call(slide.parentNode.children, slide);
      if (index >= 0) sliderEl.swiper.slideTo(index);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["workshop-image-with-text"] && !Shopify.designMode) return;
  try {
    
(function () {
  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function hidePoster(media) {
    if (media) media.classList.add('is-playing');
  }

  function bindVideo(media) {
    if (!media) return;

    var video = media.querySelector('video');
    var iframe = media.querySelector('iframe[data-src]');
    var source = media.querySelector('source[data-src]');
    var alreadyBound = media.getAttribute('data-workshop-iwt-bound') === 'true';

    function onPlaying() {
      hidePoster(media);
    }

    if (video) {
      if (source && source.getAttribute('data-src') && !source.src) {
        source.src = source.getAttribute('data-src');
        video.load();
      }

      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.autoplay = true;
      video.playsInline = true;
      video.setAttribute('muted', '');
      video.setAttribute('loop', '');
      video.setAttribute('autoplay', '');
      video.setAttribute('playsinline', '');
      video.controls = false;

      if (!alreadyBound) {
        video.addEventListener('playing', onPlaying);
        if (!video.paused && video.readyState >= 3) {
          onPlaying();
        }
      }

      var playPromise = video.play();
      if (playPromise && playPromise.catch) playPromise.catch(function () {});
    }

    if (iframe && iframe.getAttribute('data-src') && !iframe.src) {
      iframe.addEventListener('load', function () {
        try {
          iframe.contentWindow.postMessage(JSON.stringify({ event: 'listening', id: 1 }), '*');
        } catch (error) {}
        window.addEventListener('message', function onYoutubeMessage(event) {
          if (!event.origin || event.origin.indexOf('youtube') === -1) return;
          if (iframe.contentWindow !== event.source) return;
          var data = event.data;
          if (typeof data === 'string') {
            try { data = JSON.parse(data); } catch (error) { return; }
          }
          if (!data) return;
          var state = null;
          if (data.event === 'onStateChange') state = data.info;
          if (data.event === 'infoDelivery' && data.info && typeof data.info.playerState !== 'undefined') {
            state = data.info.playerState;
          }
          if (state === 1) {
            window.removeEventListener('message', onYoutubeMessage);
            onPlaying();
          }
        });
        window.setTimeout(onPlaying, 2500);
      });
      iframe.src = iframe.getAttribute('data-src');
    }

    media.setAttribute('data-workshop-iwt-bound', 'true');
  }

  function observeVideos(root) {
    if (!root) return;
    var medias = root.querySelectorAll('[data-workshop-iwt-video]');
    if (!medias.length) return;

    if (!('IntersectionObserver' in window)) {
      medias.forEach(bindVideo);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        bindVideo(entry.target);
      });
    }, { rootMargin: '120px', threshold: 0.2 });

    medias.forEach(function (media) {
      observer.observe(media);
    });
  }

  var SWIPER_CSS = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
  var SWIPER_JS = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
  var sliderRegistry = {};

  function loadSwiper() {
    if (window.Swiper) return Promise.resolve(window.Swiper);
    if (window.atClSwiperLoader) return window.atClSwiperLoader;
    if (window.workshopIwtSwiperLoader) return window.workshopIwtSwiperLoader;

    window.workshopIwtSwiperLoader = new Promise(function (resolve, reject) {
      if (!document.querySelector('link[data-at-cl-swiper], link[data-workshop-iwt-swiper]')) {
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = SWIPER_CSS;
        link.setAttribute('data-workshop-iwt-swiper', '');
        document.head.appendChild(link);
      }

      var existingScript = document.querySelector('script[data-at-cl-swiper], script[data-workshop-iwt-swiper]');
      if (existingScript) {
        existingScript.addEventListener('load', function () { resolve(window.Swiper); });
        existingScript.addEventListener('error', reject);
        return;
      }

      var script = document.createElement('script');
      script.src = SWIPER_JS;
      script.async = true;
      script.setAttribute('data-workshop-iwt-swiper', '');
      script.onload = function () { resolve(window.Swiper); };
      script.onerror = reject;
      document.head.appendChild(script);
    });

    return window.workshopIwtSwiperLoader;
  }

  function playActiveSlideVideo(sliderEl) {
    if (!sliderEl || !sliderEl.swiper) return;
    var active = sliderEl.swiper.slides[sliderEl.swiper.activeIndex];
    if (!active) return;
    var media = active.querySelector('[data-workshop-iwt-video]');
    if (media) bindVideo(media);

    sliderEl.querySelectorAll('video').forEach(function (video) {
      if (!active.contains(video) && !video.paused) video.pause();
    });
  }

  async function initSlider(root) {
    if (!root || !root.id) return;
    var sliderEl = root.querySelector('[data-workshop-iwt-slider]');
    if (!sliderEl) return;

    destroySlider(root);

    try {
      await loadSwiper();
    } catch (error) {
      return;
    }

    if (!sliderEl.isConnected || !window.Swiper) return;

    var reduceMotion = prefersReducedMotion();
    var wrap = sliderEl.closest('.workshop-img-with-text-media-col');

    sliderEl.swiper = new window.Swiper(sliderEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,
      watchOverflow: true,
      autoHeight: true,
      observer: true,
      observeParents: true,
      resizeObserver: true,
      speed: reduceMotion ? 0 : 450,
      grabCursor: !reduceMotion,
      navigation: {
        nextEl: wrap ? wrap.querySelector('[data-workshop-iwt-next]') : null,
        prevEl: wrap ? wrap.querySelector('[data-workshop-iwt-prev]') : null
      },
      a11y: {
        enabled: true,
        prevSlideMessage: 'Previous media',
        nextSlideMessage: 'Next media'
      },
      on: {
        slideChange: function () {
          playActiveSlideVideo(sliderEl);
        }
      }
    });

    sliderRegistry[root.id] = sliderEl;
    playActiveSlideVideo(sliderEl);
  }

  function destroySlider(root) {
    if (!root) return;
    var sliderEl = (root.id && sliderRegistry[root.id]) || root.querySelector('[data-workshop-iwt-slider]');
    if (sliderEl && sliderEl.swiper) {
      sliderEl.swiper.destroy(true, true);
      sliderEl.swiper = null;
    }
    if (root.id) delete sliderRegistry[root.id];
  }

  function initRoot(root) {
    if (!root) return;
    initSlider(root);
    observeVideos(root);
  }

  function initAll() {
    document.querySelectorAll('.workshop-img-with-text').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('.workshop-img-with-text') || (event.target.classList && event.target.classList.contains('workshop-img-with-text') ? event.target : null);
    if (root) initRoot(root);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('.workshop-img-with-text') || (event.target.classList && event.target.classList.contains('workshop-img-with-text') ? event.target : null);
    if (root) destroySlider(root);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var root = event.target.closest('.workshop-img-with-text');
    if (!root) return;
    var sliderEl = root.querySelector('[data-workshop-iwt-slider]');
    if (!sliderEl || !sliderEl.swiper) return;
    var slide = event.target.closest('.swiper-slide');
    if (!slide || !slide.parentNode) return;
    var index = Array.prototype.indexOf.call(slide.parentNode.children, slide);
    if (index >= 0) sliderEl.swiper.slideTo(index);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
